<div class="contenedor-topbar clearfix">
  <div class="topbar clearfix">
    <div></div>
    <div class="grid-contenedor-app-name">
      <div class="contenedor-app-name">
        <img src="assets/images/logotipo-analizamos-color.svg" class="app-name" style="margin-right: 8px; height: 40px;"
          alt="" />

        <span id="enviroment" [ngStyle]="{'background-color': backgroundNameenviroment}">
          {{enviroment}}
        </span>
      </div>
      <div class="contendor-fecha-topbar">
        <span class="md-inputfield">
          {{fecha}}
        </span>
      </div>
    </div>
    <div class="contedor-topbar-menu">
      <a id="topbar-menu-button" href="#" (click)="app.onTopbarMenuButtonClick($event)">
        <i class="material-icons">menu</i>
      </a>
      <ul class="topbar-menu fadeInDown" [ngClass]="{'topbar-menu-visible': app.topbarMenuActive}">
        <li #profile class="profile-item" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}">
          <div>
            <a (click)="app.onTopbarItemClick($event,profile)">
              <div class="profile-image">
                <img default="/assets/images/perfil/icono-perfil-usuario.svg"
                  [src]="rutImagen ? rutImagen : '/assets/images/perfil/icono-perfil-usuario.svg'" alt="">
              </div>
            </a>
            <div class="profile-info">
              <a (click)="app.onTopbarItemClick($event,profile)">
                <span class="topbar-item-name profile-name" style="text-transform: capitalize;">
                  {{nombre | filtrarnull}}
                </span>
                <span class="topbar-item-name profile-role">
                  {{usuLogueado.usuarioSistema}}
                </span>
              </a>
              <span class="topbar-item-name profile-role" style="color: #009638">
                <a (click)="app.onTopbarSubItemClick($event, 'ACTPER')" style="text-transform: uppercase;">{{
                  'LBL_PERFIL' | translate}} </a>
                |
                <a (click)="app.onTopbarSubItemClick($event, 'SALIR')" style="text-transform: uppercase;"> {{
                  'LBL_SALIR' | translate}}</a>
              </span>
            </div>
          </div>
          <ul id="menuUsuario" class="fadeInDown">
            <li class="user-header">
              <img alt="User Image" default="/assets/images/perfil/avatar.jpg"
                [src]="rutImagen ? rutImagen : '/assets/images/perfil/avatar.jpg'">
              <p style="margin-top: 2px;">
                <strong style="text-transform: capitalize;">
                  {{nombre | filtrarnull}}
                </strong>
                <br>
                <small>{{usuLogueado.usuarioSistema}}</small>
              </p>
              <p>
                <small>
                  Última Sesión : <strong>{{usuLogueado.fechaSesionAnterior}}</strong>
                </small>
              </p>
              <div [ngClass]="{'orden-roles': usuRoles.length > 4}">
                <small class="rol" *ngFor="let item of usuRoles">{{item}}</small>
              </div>
            </li>
            <li role="menuitem">
              <a (click)="app.onTopbarSubItemClick($event, 'ACTPER')">
                <i class="material-icons">person</i>
                <span>{{ 'LBL_PERFIL' | translate}}</span>
              </a>
            </li>
            <li role="menuitem">
              <a (click)="app.onTopbarSubItemClick($event, 'ACTCON')">
                <i class="material-icons">security</i>
                <span>{{ 'LBL_ACTUALIZARCONTRASENA' | translate}}</span>
              </a>
            </li>
            <li role="menuitem">
              <a (click)="app.onTopbarSubItemClick($event, 'SALIR')">
                <i class="material-icons">power_settings_new</i>
                <span>{{ 'LBL_SALIR' | translate}}</span>
              </a>
            </li>
          </ul>
        </li>
        <li>
          <a (click)="toggleNotifications()">
            <i class="topbar-icon material-icons notifications-badge-barra">notifications_none</i>
            <span class="badge-barra" *ngIf="nRecibidas > 0">{{ nNoLeidas }}</span>
            <span class="topbar-item-name">Notificaciones</span>
          </a>
          <!-- cargando -->
        </li>
        <li #fullscreen [ngClass]="{'active-topmenuitem':app.activeTopbarItem === fullscreen}">
          <a (click)="changeScreen()">
            <i class="topbar-icon material-icons">fullscreen</i>
            <span class="topbar-item-name">Completa</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>

<!--<div class="notifications-sidebar" [ngClass]="{'open': isNotificationsOpen}">
  <div class="notifications-sidebar-header">
    <div class="notifications-sidebar-title">
      <label>{{ 'SARLAFT.LBL_NOTIFICACIONES' | translate }}</label>
    </div>
    <div class="close-button" (click)="closeNotifications()">
      <i class="material-icons">highlight_off</i>
    </div>
  </div>

  <ul class="tab-menu">
    <li class="recibidas" [class.active]="selectedTab === 1" (click)="changeTab(1)">{{ 'SARLAFT.LBL_RECIBIDAS' | translate }} ({{ nRecibidas }})</li>
    <li class="espera"   [class.active]="selectedTab === 2" (click)="changeTab(2)">{{ 'SARLAFT.LBL_ENESPERA' | translate }} ({{ nEnviadas }})</li>
  </ul>

  <div class="tab-content">
    <app-loading *ngIf="cargando"></app-loading>
    <div *ngIf="!cargando" class="tab" [class.active]="selectedTab === 1">
      <ng-container *ngFor="let item of notificacionesRecibidas">
        <div class="list-content" (click)="gestionRecibidas($event, item)">
          <div class="list-content-date-time">
            <span>{{ item.fechaEnvioFecha }}</span>
            <span>{{ item.fechaEnvioHora }}</span>
          </div>
          <strong class="list-content-title">{{ item.notificacion | uppercase }}</strong>
          <p class="list-content-text">{{ item.mensaje }}</p>
        </div>
    </ng-container>
    </div>
    <div *ngIf="!cargando" class="tab" [class.active]="selectedTab === 2">
      <ng-container *ngFor="let item of notificacionesEnEspera">
        <div class="list-content-espera" (click)="gestionEnEspera($event, item)">
          <div class="list-content-date-time">
            <div class="list-content-date">
              <i class="material-icons">fiber_manual_record</i>
              <span>{{ item.fechaEnvioFecha }}</span>
            </div>
            <span>{{ item.fechaEnvioHora }}</span>
          </div>
          <strong class="list-content-title">{{ item.notificacion | uppercase }}</strong>
          <p class="list-content-text">{{ item.mensaje }}</p>
        </div>
      </ng-container>
    </div>
  </div>

</div>-->

<!-- Panel de notificaciones -->
<div class="notifications-sidebar" [ngClass]="{'open': isNotificationsOpen}">
  <!-- Header -->
  <div class="notifications-sidebar-header">
    <div class="header-title-container">
      <h2 class="notifications-sidebar-title">{{ 'SARLAFT.LBL_NOTIFICACIONES' | translate }}</h2>
      <span class="unread-badge" *ngIf="nRecibidas > 0">{{ nNoLeidas }}</span>
      <button class="clear-btn" (click)="limpiarNotificaciones()">
        <img src="assets/icons/ico-limpiar-barrer-escoba.svg" alt="Limpiar" class="broom-icon" />
        <span>{{ 'BANCOERROR.LBL_LIMPIAR' | translate }}</span>
      </button>
    </div>
    <div class="close-button" (click)="closeNotifications()">
      <i class="material-icons">highlight_off</i>
    </div>
  </div>

  <!-- Tabs -->
  <ul class="tab-menu">
    <li class="tab-item recibidas" [class.active]="selectedTab === 1" (click)="changeTab(1)">
      {{ 'SARLAFT.LBL_RECIBIDAS' | translate }} ({{ nNoLeidas }})
    </li>
    <li class="tab-item espera" [class.active]="selectedTab === 2" (click)="changeTab(2)">
      {{ 'SARLAFT.LBL_ENESPERA' | translate }} ({{ nEnviadas }})
    </li>
  </ul>

  <!-- Contenido -->
  <div class="tab-content" (scroll)="onScroll($event)">
    <app-loading *ngIf="cargando"></app-loading>

    <!-- TAB 1: Recibidas -->
    <div *ngIf="!cargando && selectedTab === 1" class="tab active">
      <div class="notifications-list" *ngIf="notificacionesRecibidas?.length; else emptyState">
        <ng-container *ngFor="let item of notificacionesRecibidas; let i = index">
          <!-- Agrupación por fecha -->
          <div class="date-group-title"
            *ngIf="i === 0 || (item.fechaEnvioFecha || item.fechaEnvio) !== (notificacionesRecibidas[i-1].fechaEnvioFecha || notificacionesRecibidas[i-1].fechaEnvio)">
            {{ obtenerEtiquetaFecha(item.fechaEnvioFecha || item.fechaEnvio) }}
          </div>

          <!-- Tarjeta de Notificación Dinámica -->
          <div class="notification-card" [ngClass]="item.indicadorLeido ? 'read-card' : 'unread-card'"
            (click)="gestionRecibidas($event, item)">
            <div class="card-icon-box" [ngClass]="item.indicadorLeido ? 'read-icon-box' : 'unread-icon-box'">
              <i class="material-icons">notifications_none</i>
            </div>
            <div class="card-body">
              <h2 class="card-title" [ngClass]="item.indicadorLeido ? 'read-title' : 'unread-title'">{{
                item.notificacion | uppercase }}</h2>
              <p class="card-message" [ngClass]="item.indicadorLeido ? 'read-message' : 'unread-message'">{{
                item.mensaje }}</p>
              <span class="card-time" [ngClass]="item.indicadorLeido ? 'read-time' : 'unread-time'">{{
                item.fechaEnvioHora || item.fechaEnvio }}</span>
            </div>
            <div class="card-right-action" *ngIf="!item.indicadorLeido">
              <span class="unread-dot"></span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <!-- TAB 2: En espera -->
    <div *ngIf="!cargando && selectedTab === 2" class="tab active">
      <div class="notifications-list" *ngIf="notificacionesEnEspera?.length; else emptyState">
        <ng-container *ngFor="let item of notificacionesEnEspera; let i = index">
          <div class="date-group-title"
            *ngIf="i === 0 || (item.fechaEnvioFecha || item.fechaEnvio) !== (notificacionesEnEspera[i-1].fechaEnvioFecha || notificacionesEnEspera[i-1].fechaEnvio)">
            {{ obtenerEtiquetaFecha(item.fechaEnvioFecha || item.fechaEnvio) }}
          </div>

          <!-- Tarjeta de Notificación Dinámica -->
          <div class="notification-card" [ngClass]="item.indicadorLeido ? 'read-card' : 'unread-card'"
            (click)="gestionEnEspera($event, item)">
            <div class="card-icon-box" [ngClass]="item.indicadorLeido ? 'read-icon-box' : 'unread-icon-box'">
              <i class="material-icons">notifications_none</i>
            </div>
            <div class="card-body">
              <h2 class="card-title" [ngClass]="item.indicadorLeido ? 'read-title' : 'unread-title'">{{
                item.notificacion | uppercase }}</h2>
              <p class="card-message" [ngClass]="item.indicadorLeido ? 'read-message' : 'unread-message'">{{
                item.mensaje }}</p>
              <span class="card-time" [ngClass]="item.indicadorLeido ? 'read-time' : 'unread-time'">{{
                item.fechaEnvioHora || item.fechaEnvio }}</span>
            </div>
            <div class="card-right-action" *ngIf="!item.indicadorLeido">
              <span class="unread-dot"></span>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div *ngIf="cargandoMas" style="text-align: center; padding: 10px; color: #6B7280; font-size: 13px;">
      <span>{{ 'BANCOERROR.LBL_CARGANDO' | translate }}</span>
    </div>
  </div>

  <!-- Estado vacío -->
  <ng-template #emptyState>
    <div class="empty-state">
      <i class="material-icons empty-icon">notifications_off</i>
      <p class="empty-text">{{ 'SARLAFT.MSG_NOTIENENOTIFICACIONES' | translate }}</p>
    </div>
  </ng-template>

  <!-- Acción inferior -->
  <div class="mark-all-wrapper" *ngIf="selectedTab === 1 && notificacionesRecibidas?.length > 0">
    <button class="mark-all-btn" (click)="marcarTodasComoLeidas()">
      <svg class="check-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#13a438" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <polyline points="20 6 9 17 4 12" />
        <polyline points="20 12 13 19 11 17" />
      </svg>
      <span>{{ 'SARLAFT.LBL_MARCARTODASLEIDAS' | translate }}</span>
    </button>
  </div>
</div>

<p-confirmDialog #cdn key="cdNotificaciones">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cdn.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cdn.accept()"></button>
  </ng-template>
</p-confirmDialog>